<template>
  <div class="row m-0">
    <transition name="fade">
      <payment-popup v-if="isPayNow" @closePay="closePay" :orderDetails="currentOrder"></payment-popup>
    </transition>
    <transition name="fade">
      <div class="row m-0 align-items-center justify-content-center loadingItem" v-if="isStoreLoading">
        <grid-loader :loading="isStoreLoading" :size="loaderSize"></grid-loader>
      </div>
    </transition>
    <div  class="col-12 p-0 px-md-3 pt-3">
      <div class="row m-0 align-items-center cursor" @click="goBack">
        <div class="col-auto pr-1">
          <ios-arrow-back-icon />
        </div>
        <div class="col-auto p-0 mb-1">
          Back
        </div>
      </div>
      <div class="row m-0">
        <div class="mb-3 col-12" v-if="currentOrder && currentOrder.details">
          <div class="row m-0 align-items-center mb-2">
            <div class="col p-0">
              <h4 class="mb-0">Order {{ currentOrder.orderNumber | formatOrdernumber }} - <span v-if="currentOrder.paid === true">Paid</span><span v-else-if="currentOrder.paid === 'error'">Payment Unsuccessful</span><span v-else>Pending</span><span class="smaller_text"> ({{currentOrder.details.paymentMethod}})</span></h4>
            </div>
            <div class="col-auto p-0" v-if="currentOrder.paid !== true">
              <button class="btn btn-outline" @click="openPay">Pay Now</button>
            </div>
          </div>
          <!-- <div class="mb-3 col-12 col-sm-6 col-md-6 col-lg-4 item"> -->
          <div class="row m-0 mb-2 order" v-for="(status, idx) in currentOrder.status" :key="idx" :class="{'complete': status.status == currentOrder.currentStatus, 'cancelled': status.status == 'cancelled' }">
            <div class="col-12 p-0" v-if="status.startTime">
              <div class="row m-0">
                <div class="col-12 p-0 mb-1">
                  {{status.startTime | date}}
                </div>
                <div class="col-12 p-0 mb-3">
                  <div class="card w-100">
                    <div class="card-body">
                      <h5 class="card-title">
                        <span v-if="status.startTime && (currentOrder.status[idx+1] && !currentOrder.status[idx+1].startTime)"> {{status.status | present}}</span>
                        <span v-else>{{status.status | past}} <span v-if="currentOrder.status[idx+1]">at {{currentOrder.status[idx+1].startTime | date }}</span></span>
                      </h5>
                      <p class="card-text" v-if="status.startTime && (currentOrder.status[idx+1] && !currentOrder.status[idx+1].startTime)">{{ status | description }}</p>
                    </div>
                  </div>
                </div>
                <div class="col-12" v-if="status.status != 'completed' && status.status != 'cancelled'">
                  <div class="border_left p-3"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridLoader from 'vue-spinner/src/MoonLoader.vue'

export default {
  data () {
    return {
      loaderSize: '50px',
      displayList: false,
      hasDelivery: true,
      orderStatus: [],
      currentOrder: {},
      isPayNow: false
    }
  },
  metaInfo () {
    return {
      title: 'Order Details Page'
    }
  },
  filters: {
    present (status) {
      if (status === 'ready') {
        return 'Your order is ready'
      }
      return status.charAt(0).toUpperCase() + status.slice(1) + ' your order'
    },
    past (status) {
      switch (status) {
        case 'confirming':
          return 'Your order was confirmed'
        case 'preparing':
          return 'Your order was prepared'
        case 'ready':
          return 'Your order was ready'
        case 'delivering':
          return 'Your order was delivered'
        case 'completed':
          return 'Your order has been completed'
      }
    },
    description (status) {
      switch (status.status) {
        case 'confirming':
          return 'Your order is being confirmed by the store.'
        case 'preparing':
          return 'Your order is currently being prepared by the store'
        case 'ready':
          return 'Your order is ready for collection'
        case 'delivering':
          return 'Your order is being delivered'
        case 'completed':
          return 'Your order has been completed'
      }
    }
  },
  computed: {
    ...mapGetters(['products', 'isStoreLoading', 'shopDetails', 'currentUser', 'orders'])
  },
  components: {
    GridLoader,
    'payment-popup': () => import('@/components/payment/Payment.vue')
  },
  mounted () {
    this.loadOrder()
  },
  watch: {
    orders () {
      if (this.currentUser.uid) {
        this.loadOrder()
      }
    }
  },
  methods: {
    changeDisplay (isList) {
      this.displayList = isList
    },
    loadOrder () {
      let id = this.$route.params.id
      this.currentOrder = this.orders.find(order => order['.key'] === id)
    },
    goBack () {
      this.$router.push('/orders')
    },
    openPay () {
      this.isPayNow = true
    },
    closePay () {
      this.isPayNow = false
    }
  }
}
</script>

<style>
.order {
  color: var(--dark-color-05);
}
.dark-mode .order {
  color: var(--light-color-05);
}
.order .card {
  border-left: 1px solid;
}
.border_left {
  border-left: 2px solid var(--dark-color-01);
}
.previous {
  color: var(--green-color);
}
.card-title {
  color: var(--dark-color);
}
.card-text {
  color: var(--dark-color-08);
}
.complete {
  color: var(--green-color);
}
.cancelled {
  color: var(--red-color);
}
.dark-mode .border_left {
  border-left: 2px solid var(--light-color-02);
}
.dark-mode .previous {
  color: var(--green-color);
}
.dark-mode .card-title {
  color: var(--light-color);
}
.dark-mode .card-text {
  color: var(--light-color-08);
}
.dark-mode .complete {
  color: var(--green-color);
}
.dark-mode .cancelled {
  color: var(--red-color);
}
.smaller_text {
  font-size: smaller;
  font-weight: normal;
}
</style>
